<template>
  <v-dialog
    v-model="isVisible"
    persistent
    max-width="400px"
    class="alert-confirm-modal"
  >
  <v-card :class="['acm-card', modalVariant === 'danger' ? 'acm-card--danger' : '']">
      <div :class="['acm-header', modalVariant === 'danger' ? 'acm-header--danger' : '']">
        <div class="acm-title">
          <v-icon size="18" class="acm-title-icon" icon="mdi-alert-circle-outline" />
          <span>{{ langKey.labelConfirmAction }}</span>
        </div>
        <v-btn
          v-if="showCancelButton"
          icon
          variant="text"
          size="small"
          class="acm-close"
          @click="handleCancel"
        >
          <v-icon icon="mdi-close" />
        </v-btn>
      </div>
      <v-card-text class="acm-body">
        <p class="acm-message">{{ modalMessage }}</p>
      </v-card-text>
      <v-card-actions class="acm-actions">
        <v-btn variant="flat" color="#586CDA" v-if="showCancelButton" class="acm-btn" @click="handleCancel">{{ langKey.buttonCancel }}</v-btn>
        <v-btn
          variant="flat"
          :color="modalVariant === 'danger' && !showCancelButton ? 'error' : (showCancelButton ? 'secondary' : '#586CDA')"
          class="acm-btn"
          @click="handleConfirm"
        >
          {{ langKey.buttonOk }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style>
.alert-confirm-modal .v-overlay__scrim {
  background-color: rgba(18, 22, 32, 0.35);
  backdrop-filter: blur(6px);
}

.alert-confirm-modal .v-overlay__content {
  border-radius: 40px;
}

.acm-card {
  border-radius: 40px;
  box-shadow: 0 18px 36px rgba(15, 20, 35, 0.2);
  overflow: hidden;
}

.acm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(90deg, #3949ab 0%, #586cda 100%);
  color: #ffffff;
}

.acm-header--danger {
  background: linear-gradient(90deg, #dc2626 0%, #ef4444 100%);
}

.acm-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.02em;
}

.acm-title-icon {
  color: #ffffff;
}

.acm-close {
  color: #ffffff;
}

.acm-body {
  padding: 24px 24px 12px 24px;
}

.acm-message {
  margin: 0;
  color: #1f2a44;
  font-size: 15px;
  line-height: 1.5;
  word-wrap: break-word;
}

.acm-actions {
  padding: 0 20px 20px 20px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.acm-btn {
  min-width: 120px;
  text-transform: none;
  font-weight: 600;
}
</style>

<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'AlertConfirmModal',
  setup() {
    const isVisible = ref(false)
    const modalMessage = ref('')
    const showCancelButton = ref(false)
    const modalVariant = ref('info')
    let resolveFunc

    const handleConfirm = () => {
      resolveFunc(true)
      cleanup()
    }

    const handleCancel = () => {
      resolveFunc(false)
      cleanup()
    }

    const cleanup = () => {
      isVisible.value = false
      modalMessage.value = ''
      showCancelButton.value = false
      modalVariant.value = 'info'
    }

    const openModal = (message, show, variant = 'info') => {
      modalMessage.value = message
      isVisible.value = true
      showCancelButton.value = show
      modalVariant.value = variant

      return new Promise((resolve) => {
        resolveFunc = resolve
      })
    }

    return {
      openModal,
      isVisible,
      modalMessage,
      showCancelButton,
      modalVariant,
      handleConfirm,
      handleCancel
    }
  }
})
</script>
